import { lyleUploadedPhotos } from './lyle-media'

export interface GalleryImage {
  src: string
  alt: string
  caption?: string
}

const studioGalleryImages: GalleryImage[] = [
  {
    src: '/images/blue-car-detailer.webp',
    alt: 'Autoglow detailer polishing a blue vehicle in the studio.',
  },
  {
    src: '/images/lyle-studio.jpg',
    alt: 'Lyle working in the Autoglow Detailing studio.',
  },
  {
    src: '/images/page-assets/packages-hero.jpg',
    alt: 'Ceramic-coated performance vehicle with water beading in the Autoglow studio.',
  },
  {
    src: '/images/paint-correction.jpg',
    alt: 'A professional detailer machine polishing a dark vehicle panel.',
  },
  {
    src: '/images/interior-detailing.jpg',
    alt: 'A luxury vehicle interior after professional detailing.',
  },
  {
    src: '/images/hero-detailing-studio.jpg',
    alt: 'Autoglow detailing studio workspace.',
  },
  {
    src: '/images/page-assets/studio-curing.jpg',
    alt: 'Vehicle paint curing in the Autoglow studio.',
  },
  {
    src: '/images/page-assets/booking-ceramic.jpg',
    alt: 'Ceramic coating being applied in the Autoglow studio.',
  },
  {
    src: '/images/page-assets/booking-paint-correction.jpg',
    alt: 'Paint correction in progress on a vehicle panel.',
  },
  {
    src: '/images/page-assets/booking-signature-detail.jpg',
    alt: 'Close-up of a detailed vehicle finish.',
  },
  {
    src: '/images/page-assets/booking-summary-service.jpg',
    alt: 'Ceramic coating being applied to a high-gloss vehicle panel.',
  },
  {
    src: '/images/hero-image.jpg',
    alt: 'Vehicle in the Autoglow studio.',
  },
  {
    src: '/images/detailing-packages.jpg',
    alt: 'Vehicle paintwork after professional detailing.',
  },
]

export const galleryImages: GalleryImage[] = [...lyleUploadedPhotos, ...studioGalleryImages]

export const galleryPreviewImages = galleryImages.slice(0, 4)
